import React from "react";
import Table from "components/table";
import useCourierTable from "./hooks/useTable";
import ModalDeleteConfirmation from "components/modals/components/DeleteConfirmation";
import { useDisclosure } from "@chakra-ui/hooks";
import { createPortal } from "react-dom";
import { ICourier } from "./types/courier.interface";
import Button from "components/button/Button";
import { TiPlus } from "react-icons/ti";
import { useNavigate } from "react-router-dom";

const Couriers = () => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    couriers,
    getCourierTableData,
    handleOpenDetail,
    handleRedirectUpdate,
    handleDeleteCourier,
  } = useCourierTable();
  const columnHeaders = [
    { name: "Nama" },
    { description: "Deskripsi" },
    { image: "Gambar" },
    { is_active: "Aktif" },
    { max_distance: "Jarak Maksimal (Km)" },
    { max_weight: "Berat Maksimal (gram)" },
    { code: "Kode" },
    { is_third_party: "Pihak Ketiga", is_closed_question: true },
    { updated_at: "Diperbarui" },
    { actions: "Aksi" },
  ];
  const [intendedItem, setIntendedItem] = React.useState<ICourier | null>(null);

  const openDeleteModal = (props: ICourier) => {
    onOpen();
    setIntendedItem(props);
  };

  React.useEffect(() => {
    getCourierTableData();

    // eslint-disable-next-line
  }, []);

  return (
    <div className="mt-3 h-full">
      <Table
        hasHeader={true}
        tableTitle="Daftar Kurir"
        tableData={couriers}
        headerActions={
          <Button
            size="fit"
            variant="primary"
            children={
              <div className="flex items-center gap-1">
                <TiPlus /> Kurir
              </div>
            }
            onClick={() => navigate("/admin/couriers/add")}
          />
        }
        columnHeaders={columnHeaders}
        handleDetail={handleOpenDetail}
        handleUpdate={handleRedirectUpdate}
        handleDelete={openDeleteModal}
      />
      {createPortal(
        <ModalDeleteConfirmation
          isOpen={isOpen}
          onClose={onClose}
          onDelete={handleDeleteCourier}
          itemName={intendedItem?.name}
          itemId={intendedItem?.id}
        />,
        document.body
      )}
    </div>
  );
};

export default Couriers;
